import React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: ${(props) => (props.$isOpen ? 'block' : 'none')};
`;

const MenuContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0; /* Position on the right side */
  width: 300px;
  height: 100%;
  background: #fff; /* Match site theme */
  color: #333;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  padding: 20px;
  transform: ${(props) => (props.$isOpen ? 'translateX(0)' : 'translateX(100%)')}; /* Slide from right */
  transition: transform 0.3s ease-in-out;
  border-left: 1px solid #ddd; /* Subtle border */

  h3 {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  }
`;

const CloseButton = styled.div`
  font-size: 1.5em;
  cursor: pointer;
  align-self: flex-end;
  margin-bottom: 20px;
  transition: color 0.3s ease-in-out;

  &:hover {
    color: #543230;
  }
`;

const MenuList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  flex-grow: 1;

  li {
    margin: 15px 0;
    font-size: 1em;
    cursor: pointer;
    font-weight: ${(props) => (props.selected ? 'bold' : 'normal')};
    transition: color 0.3s ease-in-out;

    &:hover {
      color: #543230;
    }
  }
`;

const SortMenu = ({ isOpen, onClose, onSortChange, selectedSort }) => {
  const handleSortClick = (sortOption) => {
    if (onSortChange) {
      onSortChange(sortOption);
    }
    onClose(); // Close menu after selecting an option
  };

  return (
    <>
      <Overlay $isOpen={isOpen} onClick={onClose} />
      <MenuContainer $isOpen={isOpen}>
        <CloseButton onClick={onClose}>×</CloseButton>
        <h3>SORT BY</h3>
        <MenuList>
          <li selected={selectedSort === 'recommended'} onClick={() => handleSortClick('recommended')}>Recommended</li>
          <li selected={selectedSort === 'new-arrivals'} onClick={() => handleSortClick('new-arrivals')}>New arrivals</li>
          <li selected={selectedSort === 'price-asc'} onClick={() => handleSortClick('price-asc')}>Price: Low to high</li>
          <li selected={selectedSort === 'price-desc'} onClick={() => handleSortClick('price-desc')}>Price: High to low</li>
        </MenuList>
      </MenuContainer>
    </>
  );
};

export default SortMenu;
